<template>
    <div>
        <div class="filterBg base-form-div">
            <el-form size="mini" :model="searchForm" label-position="right" label-width="120px" inline>
                <el-form-item label="舰船型号:">
                    <el-select @change="getTree" v-model="searchForm.type" placeholder="请选择舰船型号">
                        <el-option v-for="item in optionsType" :key="item.type" :label="item.type" :value="item.type">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div>
                <el-button class="base-button" type="primary" icon="el-icon-search" @click="getTree">查询</el-button>
            </div>
        </div>
        <div @click="equipmentTreeClick" class="lonTree-div baseTree">
            <el-tree @node-contextmenu="contextmenu" @node-click="equipmentTreeClick" :expand-on-click-node="false"
                :data="Listdata" :default-expanded-keys="defaultExpandedKeys" node-key="name" ref="tree"
                :props="defaultProps">
            </el-tree>
        </div>
    </div>
</template>

<script>
import { getTreeQueryGzxxList } from "@/api/equipmentDic/index"
import { getCommonAjax } from "@/api/common"
import sendMsg from "./sendMsg.vue"
export default {
    data() {
        return {
            Listdata: [
                {
                    id: 0,
                    name: '根节点',
                    children: [],
                    isRoot:true,
                    obj: {
                        id: 0
                    }
                }
            ],
            defaultExpandedKeys: [1],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            optionsType: [],
            searchForm: {
                type: ""
            }
        };
    },
    created() {
        this.getShipType();
    },

    mounted() {
        this.$bus.$on("faultPheon-list", () => {
            this.getTree();
        });
    },
    beforeDestroy() {
        this.$bus.$off("faultPheon-list");
    },

    methods: {
        getShipType() {
            getCommonAjax("/wx/queryTypeList", {}).then(res => {
                this.optionsType = res.result;
                if (this.optionsType && this.optionsType.length > 0) {
                    this.searchForm.type = this.optionsType[0].type;
                    this.getTree();
                }
            }).catch(err => {
                console.error(err);
            });
        },
        equipmentTreeClick() {
            // alert()
            this.closeMsg();
        },
        closeMsg() {
            if (window.rightIns) {
                this.$dialog.close(window.rightIns);
                window.rightIns = undefined;
            }
        },
        getTree() {
            this.Listdata[0].name = this.searchForm.type;
            this.Listdata[0].model = this.searchForm.type + "_0";
            getTreeQueryGzxxList({ type: this.searchForm.type }).then(res => {
                var list = res.result || [];
                this.Listdata[0].children = list;
                this.$nextTick(() => {
                    this.defaultExpandedKeys = list.map(n => {
                        return n.name;
                    });
                });

            }).catch(e => {
                console.error(e)
            });
        },
        contextmenu(event, data, node, el) {
            //this.defaultExpandedKeys = [data.obj.id];
            data.rootType=this.searchForm.type;
            this.closeMsg();
            var pageX = event.pageX;
            var pageY = event.pageY + 10;
            window.rightIns = this.$dialog.open({
                shade: false,
                hasHead: false,
                theme: "right-dialog",
                location: {
                    left: pageX + "px",
                    top: pageY + "px",
                    right: undefined,
                    bottom: undefined
                },
                content: {
                    type: "vue",
                    subCom: sendMsg,
                    subData: data
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.lonTree-div {
    height: 540px;
    position: relative;
    z-index: 9;
    overflow-y: auto;
}
</style>